import { ReactNode } from 'react';
import { toast } from 'react-toastify';

const warning = (message: string | ReactNode) => {
  toast.warning(message, {
    className: '--toastify-color-warning',
  });
};

export default warning;
